import type { FC } from 'react'
import styled from 'styled-components'

import { MobileHiddenView } from 'components/Media'
import { FlexDivCol, FlexDivRowCentered } from 'components/layout/flex'

import Banner from '../../HomeLayout/Banner'
import Logo from '../../Logo'
import Menu from './Nav/Menu'
import Nav from './Nav/Nav'
import WalletButtons from './WalletButtons'

const Header: FC = () => {
	return (
		<MobileHiddenView>
			<FlexDivCol>
				<Container>
					<FlexDivRowCentered>
						<Logo />
						<FlexDivRowCentered columnGap="24px">
							<Menu />
							<Nav />
						</FlexDivRowCentered>
					</FlexDivRowCentered>
					<WalletButtons />
				</Container>
				<Banner />
			</FlexDivCol>
		</MobileHiddenView>
	)
}

const Container = styled.header`
	background-color: ${(props) => props.theme.colors.selectedTheme.newTheme.containers.primary.background};
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 15px;
	border-bottom: ${(props) => props.theme.colors.selectedTheme.border};
`

export default Header
